<svg class="block size-44" role="img" [attr.viewBox]="'0 0 ' + 176 + ' ' + 176" [attr.aria-label]="ariaLabel()">
	<g [attr.transform]="'translate(' + 88 + ' ' + 88 + ')'">
		@for (slice of renderedSlices(); track slice.name) {
			<path
				stroke-width="1"
				stroke-linejoin="round"
				[attr.stroke]="slice.isFullCircle ? 'none' : 'var(--color-gray-000)'"
				[attr.d]="slice.path"
				[attr.fill]="slice.color"
				[attr.aria-label]="slice.name + ': ' + (slice.percentage | number: '1.0-0') + '%'" />
		}
		@for (slice of renderedSlices(); track slice.name) {
			@if (slice.showLabel) {
				<text
					fill="var(--color-gray-000)"
					text-anchor="middle"
					dominant-baseline="central"
					font-size="12"
					font-weight="700"
					aria-hidden="true"
					[attr.x]="slice.labelX"
					[attr.y]="slice.labelY">
					{{ slice.percentage | number: '1.0-0' }}%
				</text>
			}
		}
	</g>
</svg>
